import { Link } from "react-router-dom";

const SECRETS = [
  {
    icon: "ri-user-search-line",
    title: "云渺的身世",
    desc: "外门师妹云渺来路成谜，她与云隐峰之间，似乎藏着一桩旧年因果。",
  },
  {
    icon: "ri-flashlight-line",
    title: "掌门的布局",
    desc: "玄真子表面威严古板，暗中的每一步棋，都在为云隐峰铺一条更长路。",
  },
  {
    icon: "ri-vip-diamond-line",
    title: "魔修的旧怨",
    desc: "顾长风的纠缠不止于正邪立场，他与大师兄之间，横着一道未解的旧伤。",
  },
  {
    icon: "ri-eye-2-line",
    title: "护短下的伏笔",
    desc: "越是浓烈的同门情谊，越可能是暗线最好的藏身处，处处皆可考据。",
  },
];

export default function SecretLines() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20Chinese%20ink%20wash%20cultivation%20scene%20at%20night%2C%20ancient%20sect%20hall%20lit%20by%20a%20few%20lanterns%20in%20heavy%20mist%2C%20mysterious%20atmosphere%2C%20deep%20indigo%20and%20crimson%20shadows%2C%20cinematic%2C%20refined%20detail&width=1920&height=900&seq=secret-band-01&orientation=landscape"
          alt="夜幕下云雾缭绕的修仙门派暗线背景"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-background-950/85"></div>

      <div className="relative mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-medium tracking-[0.3em] text-accent-300">HIDDEN THREADS</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-4xl">
            同门情谊暗线全梳理
          </h2>
          <div className="gold-line mx-auto mt-4 h-px w-16"></div>
          <p className="mt-4 text-sm leading-7 text-foreground-100/80">
            温馨的师门日常之下，藏着被读者反复考据的暗线。把散落的伏笔串起来，才是真正的追更乐趣。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {SECRETS.map((s) => (
            <div key={s.title} className="rounded-lg border border-background-700/60 bg-background-950/40 p-6 backdrop-blur">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-500/15 text-accent-300 text-2xl">
                <i className={s.icon} />
              </span>
              <h3 className="mt-4 font-heading text-lg text-background-50">{s.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-100/70">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/relations"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-accent-400/40 px-7 py-3 text-sm text-accent-200 transition-colors hover:bg-accent-500/10"
          >
            深入暗线考据 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}